import React, { FC } from 'react';
import { Skeleton, Stack } from '@mui/material';

export const HeaderTitleSkeleton: FC = () => {
  return (
    <>
      {/* DESKTOP VIEW */}
      <Stack
        direction="row"
        flex={1}
        gap={5}
        alignItems="center"
        sx={{ display: { xs: 'none', md: 'flex' }, width: '100%' }}
      >
        {/* Futures tag */}
        <Skeleton variant="rounded" width={60} height={24} />

        <Stack direction="row" flex={1} alignItems="center" gap={3}>
          {/* Main title */}
          <Skeleton variant="text" width={150} height={48} />

          {/* Dropdown icon */}
          <Skeleton variant="circular" width={20} height={20} />

          {/* Active status tag */}
          <Skeleton variant="rounded" width={70} height={24} />

          {/* Evaluation tag */}
          <Skeleton variant="rounded" width={80} height={24} />
        </Stack>
      </Stack>

      {/* MOBILE VIEW */}
      <Stack
        direction="column"
        gap={1.5}
        alignItems="flex-start"
        sx={{ display: { xs: 'flex', md: 'none' }, width: '100%' }}
      >
        {/* Tag row */}
        <Stack direction="row" gap={3}>
          <Skeleton variant="rounded" width={60} height={24} />
          <Skeleton variant="rounded" width={70} height={24} />
          <Skeleton variant="rounded" width={80} height={24} />
        </Stack>

        {/* Title row */}
        <Stack direction="row" alignItems="center" gap={1}>
          <Skeleton variant="text" width={150} height={48} />
          <Skeleton variant="circular" width={20} height={20} />
        </Stack>
      </Stack>
    </>
  );
};
